module.exports = __webpack_public_path__ + "img/carousel_ellipse.da463761.svg";